module.exports = __webpack_public_path__ + "static/media/IdealProductCostIcon.7a6c71dc.svg";